import React from 'react';
import LineGraph from '../../../../../components/linegraph';
import { getDateRange, getTrendIndicator } from '../../../../../utils/performanceUtils';
import { KPI_DECIMAL_PLACES } from '../../../../../constants/constants';
import { useAppSelector } from '../../../../../redux';
import { selectOverallPerformanceData } from '../../../../../redux/PerformanceReducer/Overall/overallSlice';

/**
 * BusinessToBusinessGraphs component displays B2B performance line graphs
 * Accesses performance data directly from Redux store
 */
const BusinessToBusinessGraphs: React.FC = (): JSX.Element => {
  const data = useAppSelector(selectOverallPerformanceData);
  const b2bSales = data?.B2S;
  const b2bTransactions = data?.B2T;
  const b2bGrossProfit = data?.B2P;

  return (
    <>
      <LineGraph
        title={b2bSales?.title}
        mainValue={b2bSales?.currentYtdAmount}
        format={b2bSales?.format}
        decimalPlaces={KPI_DECIMAL_PLACES[b2bSales?.kpiCode ?? '']}
        datasets={b2bSales?.datasets}
        trendIndicator={getTrendIndicator(b2bSales)}
        dateRange={getDateRange(b2bSales)}
      />
      <LineGraph
        title={b2bTransactions?.title}
        mainValue={b2bTransactions?.currentYtdAmount}
        format={b2bTransactions?.format}
        decimalPlaces={KPI_DECIMAL_PLACES[b2bTransactions?.kpiCode ?? '']}
        datasets={b2bTransactions?.datasets}
        trendIndicator={getTrendIndicator(b2bTransactions)}
        dateRange={getDateRange(b2bTransactions)}
      />
      <LineGraph
        title={b2bGrossProfit?.title}
        mainValue={b2bGrossProfit?.currentYtdAmount}
        format={b2bGrossProfit?.format}
        decimalPlaces={KPI_DECIMAL_PLACES[b2bGrossProfit?.kpiCode ?? '']}
        datasets={b2bGrossProfit?.datasets}
        trendIndicator={getTrendIndicator(b2bGrossProfit)}
        dateRange={getDateRange(b2bGrossProfit)}
      />
    </>
  );
};

export default BusinessToBusinessGraphs;
